var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import Config from 'src/config';
export function validateSds(result) {
    return result.code === 0;
}
export function mapSds(response) {
    if (!response || typeof response !== 'object') {
        return response;
    }
    const result = response.result !== undefined ? response.result : response;
    if (!result || typeof result !== 'object') {
        return result;
    }
    const { cols, rows } = result;
    if (!cols) {
        return rows || result;
    }
    const keys = Object.keys(cols);
    const mapped_data = [];
    result.rows.forEach((row) => {
        const values = Object.values(row);
        const mapped = values.reduce((a, it, index) => (Object.assign(Object.assign({}, a), { [keys[index]]: it })), {});
        mapped_data.push(mapped);
    });
    return mapped_data;
}
export function sdsWrapper(api) {
    return Config.sds_base_url + api;
}
export function timeWrapper(api) {
    return api;
}
export function fetchSds(api, options) {
    return __awaiter(this, void 0, void 0, function* () {
        //  const response = await fetch(sdsWrapper(api), {
        const response = yield fetch(timeWrapper(api), Object.assign({ keepalive: true }, options));
        // If the status code is not in the range 200-299,
        // we still try to parse and throw it.
        if (!response.ok) {
            const error = new Error('An error occurred while fetching the data.');
            // Attach extra info to the error object.
            error.info = yield response.json();
            error.status = response.status;
            throw error;
        }
        const result = yield response.json();
        if (validateSds(result)) {
            const parsed = mapSds(result); // Assuming mapSds returns the correct type
            return parsed;
        }
        else {
            throw new Error(result.error);
        }
    });
}
